import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteProjectStepDialogProps = {
  open: boolean;
  projectStepId: number | null;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteProjectStepDialog = ({
  open,
  projectStepId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteProjectStepDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    if (!projectStepId) return;

    try {
      setLoading(true);

      const response = await apiService.deleteProjectStep(projectStepId);

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="projectStepManaging.deleteProjectStepCompleted"
            defaultMessage="Seçili proje adımını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="projectStepManaging.deleteProjectStep" defaultMessage="Proje Adımı Sil" />}
      description={
        <FormattedMessage
          id="projectStepManaging.deleteProjectStepRepeat"
          defaultMessage="Bu işlem onaylandıktan sonra proje adımı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteProjectStepDialog;
